import { render, staticRenderFns } from "./switchLang.vue?vue&type=template&id=5d0b4001"
import script from "./switchLang.vue?vue&type=script&lang=js"
export * from "./switchLang.vue?vue&type=script&lang=js"
import style0 from "./switchLang.vue?vue&type=style&index=0&id=5d0b4001&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports